import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {CompleteDetailsFilter} from '../components/complete-details-filter/CompleteDetailsFilter';
import {CompleteDetailsTable} from '../components/complete-details-table/CompleteDetailsTable';
import {CompleteDetailsFooter} from '../components/complete-details-footer/CompleteDetailsFooter';
import FooterBar from '../../_common/components/FooterBar';

export function CompleteDetailsCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'complete-details-list-card'}>
      <CompleteDetailsFilter/>
      <CompleteDetailsTable/>
      <FooterBar>
        <CompleteDetailsFooter/>
      </FooterBar>
    </Card>
  );
}
